import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router'
import { store, history } from './helpers'
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';



const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <Provider store={store}>
      <ConnectedRouter history={history}>
          <App />  
      </ConnectedRouter>
  </Provider>
);


